'use client';

import type { SavedQuery } from '@repo/api-gw-sdk';
import { useCallback } from 'react';

import { DeleteEntityDialog } from '@/components/lakehouse/deleteEntityDialog';
import { useDAL } from '@/contexts/useDAL';

interface DeleteSavedQueryDialogProps {
  savedQuery: SavedQuery;
  workspaceId: string;
  open: boolean;
  onClose: () => void;
  onDeleted: () => void;
}

export const DeleteSavedQueryDialog = ({
  savedQuery,
  workspaceId,
  open,
  onClose,
  onDeleted,
}: DeleteSavedQueryDialogProps) => {
  const dal = useDAL();

  const handleDelete = useCallback(async () => {
    await dal.lakehouse.deleteSavedQuery(workspaceId, savedQuery.id);
    onDeleted();
  }, [dal, workspaceId, savedQuery.id, onDeleted]);

  return (
    <DeleteEntityDialog
      open={open}
      title='Delete Saved Query'
      entityLabel='saved query'
      entityName={savedQuery.name}
      onClose={onClose}
      onDelete={handleDelete}
      testIdPrefix='delete-saved-query'
    />
  );
};
